/*
 *@Description: 全局eventBus
 *@param {arg} type
 *@return [type]
 *@Date: 2019-07-11 15:51:09
 */
import Vue from "vue";
export const bus = new Vue();

let oldLang = ""
export function changeLang(lang) {
  if(oldLang === lang)return;
  oldLang = lang;
  document.documentElement.lang = lang;
  document.documentElement.className = lang;
  if (lang === "ar") {
    document.documentElement.dir = "rtl";
  } else {
    document.documentElement.dir = "ltr";
  }
}
